import script from "./ListarPeriodosAvaliacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPeriodosAvaliacoes.vue?vue&type=script&setup=true&lang=js"

import "./ListarPeriodosAvaliacoes.vue?vue&type=style&index=0&id=10070481&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10070481"]])

export default __exports__